import { render } from "./PersonalCoding.vue?vue&type=template&id=be2f95c8&scoped=true"
import script from "./PersonalCoding.vue?vue&type=script&lang=js"
export * from "./PersonalCoding.vue?vue&type=script&lang=js"

import "./PersonalCoding.vue?vue&type=style&index=0&id=be2f95c8&scoped=true&lang=css"
import "./PersonalCoding.vue?vue&type=style&index=1&id=be2f95c8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be2f95c8"]])

export default __exports__